import React from 'react'
import { CrowdfundIcon, HideIcon } from '@paypalcorp/pp-react'
import serverData from '../../utils/server-data'
import {
  isAnonymousAmountEnabled,
  isUserSpecificEaseOfUseIntroEnabled,
  isUserSpecificTransparencyEnabled,
  isUserTypeAgnosticIntroEnabled,
} from '../../utils/features'
import { SHEET_SOURCE } from '../../constants'

export function getIntroItem(isSmallScreen: boolean, sheetSource: string) {
  let userType = 'agnostic'
  if (isUserSpecificEaseOfUseIntroEnabled()) {
    userType = 'easeOfUse'
  } else if (isUserSpecificTransparencyEnabled()) {
    userType = 'transparency'
  }

  const role =
    sheetSource === SHEET_SOURCE.CREATE_GROUP_BUTTON ? 'creator' : 'contributor'
  const universalImage =
    serverData?.ui?.introDiscoverabilityExperimentImages?.universalImage || {}
  const title = 'create.intro.creator.title'
  const firstSubtitle = 'create.intro.universal.trackItem'
  const contentMap = {
    agnostic: {
      creator: {
        title,
        firstSubtitle,
        images: universalImage,
      },
      contributor: {
        title,
        firstSubtitle,
        images: universalImage,
      },
    },
    easeOfUse: {
      creator: {
        title,
        firstSubtitle,
        images: universalImage,
      },
      contributor: {
        title: 'create.intro.easeOfUse.contributor.title',
        firstSubtitle,
        images: universalImage,
      },
    },
    transparency: {
      creator: {
        title: 'create.intro.transparency.creator.title',
        firstSubtitle,
        images: universalImage,
      },
      contributor: {
        title: 'create.intro.easeOfUse.contributor.title',
        firstSubtitle,
        images: universalImage,
      },
    },
  }

  const currentContent =
    contentMap[userType as keyof typeof contentMap]?.[role] ||
    contentMap.agnostic[role]
  let itemId = 'firstPanelIntroContent'
  if (isUserSpecificEaseOfUseIntroEnabled()) {
    itemId = 'introUserSpecificEaseOfUse'
  } else if (isUserSpecificTransparencyEnabled()) {
    itemId = 'introUserSpecificTransparency'
  } else if (isUserTypeAgnosticIntroEnabled()) {
    itemId = 'introUserAgnosticContent'
  }
  const secondSubtitle = isAnonymousAmountEnabled()
    ? 'intro.anonymousTransaction.privacyItem'
    : 'create.intro.privacyItem'
  return {
    id: itemId,
    images: currentContent.images,
    title: currentContent.title,
    firstIcon: (
      <CrowdfundIcon size={isSmallScreen ? 'sm' : 'md'} aria-hidden="true" />
    ),
    firstSubtitle: currentContent.firstSubtitle,
    secondIcon: (
      <HideIcon size={isSmallScreen ? 'sm' : 'md'} aria-hidden="true" />
    ),
    secondSubtitle,
    showPrivacyLink: true,
  }
}
